﻿import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  Typography,
  Container,
  Grid,
  TextField,
} from "@mui/material";
import "./EditQualifiersReadOptions.css";
import {
  selectSelectedConnection,
  fetchReadOptionFields,
  selectReadOptionFields,
} from "@/features/connections/integrationSlice";
import { useDispatch, useSelector } from "react-redux";

const EditQualifiersReadOptions = forwardRef(
  ({ isTransactionSettings, selectedTransaction }, ref) => {
    const dispatch = useDispatch();

    const selectedConnection = useSelector(selectSelectedConnection);


    const [artifactType, setArtifactType] = useState(-1); //To represent the global
    const [endpointSchemaId, setEndpointSchemaId] = useState(0); //To represent the global

    useEffect(() => {
      if (isTransactionSettings) {
        setArtifactType(selectedTransaction[0].artifactType); //To represent the transaction set level
        setEndpointSchemaId(selectedTransaction[0].endpointSchemaId); //To represent the transaction set level
      }
    }, [isTransactionSettings, selectedTransaction]);

    useEffect(() => {
      if (selectedConnection.ConnectionId) {
        if (isTransactionSettings) {
          dispatch(
            fetchReadOptionFields({
              connectionId: selectedConnection.ConnectionId,
              artifactType: selectedTransaction[0].artifactType,
            })
          );
        } else if (!isTransactionSettings) {
          dispatch(
            fetchReadOptionFields({
              connectionId: selectedConnection.ConnectionId,
              artifactType: -1,
            })
          );
        }
      }
    }, [selectedConnection.ConnectionId, selectedTransaction]);

    const readOptionFields = useSelector(selectReadOptionFields);

    const [dataValues, setDataValues] = useState({});

    useEffect(() => {
      if (readOptionFields && Object.keys(readOptionFields).length > 0) {
        setDataValues(readOptionFields);
      }
    }, [readOptionFields]);

    const handleChange = (event) => {
      const { name, value } = event.target;
      setDataValues((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };

    const getFormData = () => {
      return { ...dataValues };
    };

    useImperativeHandle(ref, () => ({
      getFormData,
    }));

    return (
      <Container>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{
            justifyContent: "center",
          }}
        >
          <Grid item xs={1.5}></Grid>
          <Grid item xs={9}>
            <Typography variant="h2" sx={{ marginBottom: "20px" }}>
              EDI Qualifiers
            </Typography>
          </Grid>
          <Grid item xs={1.5}></Grid>

          <Grid item xs={1.5}></Grid>
          <Grid item xs={9}>
            <Typography sx={{ marginBottom: "20px" }}>
              Multiple qualifiers can be entered if separated by spaces or commas.
            </Typography>
          </Grid>
          <Grid item xs={1.5}></Grid>

          <Grid item xs={1.5} />
          <Grid item xs={9}>
            <Typography sx={{ marginBottom: "20px" }}>
              Location Qualifiers
            </Typography>
          </Grid>
          <Grid item xs={1.5}></Grid>

          <Grid item xs={1.5}></Grid>
          <Grid item xs={3}>
            <Typography>
              Ship To
            </Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="ShipToQualifier"
                value={dataValues?.ShipToQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Ship From</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="ShipFromQualifier"
                value={dataValues?.ShipFromQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Bill To</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="BillToQualifier"
                value={dataValues?.BillToQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={1.5} />

          <Grid item xs={1.5} />
          <Grid item xs={9}>
            <Typography sx={{ marginBottom: "20px" }}>Date/Time Qualifiers</Typography>
          </Grid>
          <Grid item xs={1.5}></Grid>

          <Grid item xs={1.5}></Grid>
          <Grid item xs={3}>
            <Typography>
              DT Segment ID
            </Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="DTSegmentId"
                value={dataValues?.DTSegmentId || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>DT Position</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="DTQualifierPosition"
                value={dataValues?.DTQualifierPosition || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Ship Date</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="ShipDateQualifier"
                value={dataValues?.ShipDateQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={1.5} />

          <Grid item xs={1.5}></Grid>
          <Grid item xs={3}>
            <Typography>
              Delivery Date
            </Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="DeliveryDateQualifier"
                value={dataValues?.DeliveryDateQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Cancel Date</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="CancelDateQualifier"
                value={dataValues?.CancelDateQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Receive Date</Typography>
            <Typography>
              <TextField
                variant="outlined"
                name="ReceiveDateQualifier"
                value={dataValues?.ReceiveDateQualifier || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={1.5} />
        </Grid>
      </Container>
    );
  }
);

export default EditQualifiersReadOptions;
